module.exports = __webpack_public_path__ + "static/media/deplacement.5d8d7cec.mp3";